export const GENDER_OPTIONS = [
  {
    value: "M",
    label: "Masculin",
    shortLabel: "M",
  },
  {
    value: "F",
    label: "Féminin",
    shortLabel: "F",
  },
];

/*
 * Les âges sont calculés à partir de l'année de référence,
 * qui correspond à l'année de début de saison.
 *
 * Exemple :
 * saison 2025-2026 -> année de référence 2025.
 */
export const AGE_CATEGORIES = [
  {
    key: "EVEIL",
    labels: {
      M: "Éveil Judo",
      F: "Éveil Judo",
    },
    minAge: 4,
    maxAge: 5,
    weightRule: "MORPHOLOGICAL",
    accent: "violet",
  },
  {
    key: "MINI_POUSSIN",
    labels: {
      M: "Mini-Poussin",
      F: "Mini-Poussine",
    },
    minAge: 6,
    maxAge: 7,
    weightRule: "MORPHOLOGICAL",
    accent: "cyan",
  },
  {
    key: "POUSSIN",
    labels: {
      M: "Poussin",
      F: "Poussine",
    },
    minAge: 8,
    maxAge: 9,
    weightRule: "MORPHOLOGICAL",
    accent: "blue",
  },
  {
    key: "BENJAMIN",
    labels: {
      M: "Benjamin",
      F: "Benjamine",
    },
    minAge: 10,
    maxAge: 11,
    weightRule: "BENJAMIN",
    accent: "emerald",
  },
  {
    key: "MINIME",
    labels: {
      M: "Minime",
      F: "Minime",
    },
    minAge: 12,
    maxAge: 13,
    weightRule: "MINIME",
    accent: "lime",
  },
  {
    key: "CADET",
    labels: {
      M: "Cadet",
      F: "Cadette",
    },
    minAge: 14,
    maxAge: 16,
    weightRule: "CADET",
    accent: "amber",
  },
  {
    key: "JUNIOR",
    labels: {
      M: "Junior",
      F: "Junior",
    },
    minAge: 17,
    maxAge: 19,
    weightRule: "JUNIOR",
    accent: "orange",
  },
  {
    key: "SENIOR",
    labels: {
      M: "Senior",
      F: "Senior",
    },
    minAge: 20,
    maxAge: Infinity,
    weightRule: "SENIOR",
    accent: "red",
  },
];

export const VETERAN_CATEGORIES = [
  { index: 1, minAge: 30, maxAge: 34 },
  { index: 2, minAge: 35, maxAge: 39 },
  { index: 3, minAge: 40, maxAge: 44 },
  { index: 4, minAge: 45, maxAge: 49 },
  { index: 5, minAge: 50, maxAge: 54 },
  { index: 6, minAge: 55, maxAge: 59 },
  { index: 7, minAge: 60, maxAge: 64 },
  { index: 8, minAge: 65, maxAge: 69 },
  { index: 9, minAge: 70, maxAge: 74 },
  { index: 10, minAge: 75, maxAge: 79 },
  { index: 11, minAge: 80, maxAge: Infinity },
];

/*
 * Les nombres représentent les limites supérieures.
 *
 * Exemple :
 * [26, 30, 34] produit les catégories
 * -26 kg, -30 kg, -34 kg...
 */
export const WEIGHT_LIMITS = {
  BENJAMIN: {
    M: [26, 30, 34, 38, 42, 46, 50, 55, 60, 66],
    F: [28, 32, 36, 40, 44, 48, 52, 57, 63],
  },

  MINIME: {
    M: [34, 38, 42, 46, 50, 55, 60, 66, 73],
    F: [36, 40, 44, 48, 52, 57, 63, 70],
  },

  CADET: {
    M: [46, 50, 55, 60, 66, 73, 81, 90],
    F: [40, 44, 48, 52, 57, 63, 70],
  },

  JUNIOR: {
    M: [55, 60, 66, 73, 81, 90, 100],
    F: [44, 48, 52, 57, 63, 70, 78],
  },

  SENIOR: {
    M: [60, 66, 73, 81, 90, 100],
    F: [48, 52, 57, 63, 70, 78],
  },
};

export const MORPHOLOGICAL_LABEL =
  "Groupes morphologiques";